"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const styles_1 = require("../styles");
const ReadOnlyWrapper = (0, styled_1.default)(styles_1.Text) `
  margin: 0px;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  border: 1px ${(0, ui_theme_1.fromTheme)('color_background_disabled_form_input')} solid;
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_xlarge')}
    ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-color: ${(props) => props.hasErrors
    ? (0, ui_theme_1.fromTheme)('color_danger')
    : (0, ui_theme_1.fromTheme)('color_background_disabled_form_input')};
  ${styles_1.mixins.rowWidth}
`;
const ReadOnly = ({ msg, hasErrors = false }) => {
    const toDisplay = msg ? msg : 'None Provided'; // don't display empty strings
    return (react_1.default.createElement(ReadOnlyWrapper, { hasErrors: hasErrors, "data-testid": "forms-v2-read-only" }, toDisplay));
};
exports.default = ReadOnly;
//# sourceMappingURL=read-only.js.map